import React, { useEffect, useMemo } from 'react';
import _debounce from 'lodash/debounce';
import classNameBind from 'classnames/bind';
import { withTranslation } from '../../../Translator';
import { TextField } from '../../../TextField';
import styles from './Search.module.css';

const bindClasses = classNameBind.bind(styles);

const Search = ({ t, value, placeholder, onSearch = () => {}, onSearchChange, debounceTime }) => {
  const debouncedChangeHandler = useMemo(
    () => _debounce(e => onSearch(e), debounceTime),
    [],
  );

  useEffect(() => {
    debouncedChangeHandler.cancel();
  }, [debouncedChangeHandler]);

  return (
    <div className={bindClasses('wrapper')} data-ppuc-id="Sidebar.Search">
      <TextField
        name="search"
        type="text"
        icon="search"
        value={value}
        placeholder={placeholder || t('ListSidebar.searchPlaceholder')}
        onChange={(e) => {
          onSearchChange(e);

          if (debounceTime) {
            debouncedChangeHandler(e);
          } else {
            onSearch(e);
          }
        }}
        clearable
      />
    </div>
  );
};

export default withTranslation('components')(Search);
